module.exports = __webpack_public_path__ + "img/clipboard-with-doc.bba6db38.png";